<div class="action-arrow__content" *ngIf="cellValue.files && cellValue.files.length">
	<button class="btn btn-secondary btn-sm" (click)="onDownloadDocument($event)">
		<i class="fa fa-download"></i>
	</button>
</div>
